import React from 'react';
import { HeadingWrapper } from './private/headingWrapper';
import { DialogContainer, DialogMain } from './private/layout';
import { DialogToggle, DialogToggleText } from './private/toggle';
import DialogContent from '../dialogContent/DialogContent';
import DialogOverlay from '../dialogOverlay/DialogOverlay';
import IconClose from '../private/icons/IconClose';
const DialogToggleComponent = ({ backgroundColor, heading, hideCloseButton, onDismiss, }) => {
    if (hideCloseButton) {
        return null;
    }
    return (React.createElement(DialogToggle, { type: "button", onClick: onDismiss && onDismiss, heading: !!heading, backgroundColor: backgroundColor },
        React.createElement(IconClose, null),
        React.createElement(DialogToggleText, null, "Close dialog")));
};
const DialogHeaderComponent = ({ onDismiss, heading, hideCloseButton, }) => (React.createElement(HeadingWrapper, null,
    heading,
    React.createElement(DialogToggleComponent, { onDismiss: onDismiss, heading: heading, hideCloseButton: hideCloseButton })));
const Dialog = ({ backgroundColor, children, disableScrollLock = false, disableFocusLock = false, heading, hideCloseButton = false, isOpen = false, maxWidth, onDismiss, position = 'CENTER', variant, }) => (React.createElement(DialogOverlay, { isOpen: isOpen && isOpen, onDismiss: onDismiss && onDismiss, dangerouslyBypassScrollLock: disableScrollLock, dangerouslyBypassFocusLock: disableFocusLock },
    React.createElement(DialogContent, { maxWidth: maxWidth, position: position },
        React.createElement(DialogContainer, { backgroundColor: backgroundColor, variant: variant },
            !heading && (React.createElement(DialogToggleComponent, { backgroundColor: backgroundColor, hideCloseButton: hideCloseButton, onDismiss: onDismiss })),
            React.createElement(DialogMain, { variant: variant },
                heading && (React.createElement(DialogHeaderComponent, { onDismiss: onDismiss, heading: heading, hideCloseButton: hideCloseButton })),
                children)))));
export default Dialog;
